// CSS to customise the ttyd/xterm frames and fix the ability to click the scrollbar
export var ttydIFrameCSS = "\n.xterm-accessibility { margin-right: 20px }\n.xterm .xterm-viewport { overflow: auto }\n#terminal-container .terminal { padding: 8px }\n";
